import { render, staticRenderFns } from "./uploadDelivery.vue?vue&type=template&id=5c53c1ae&scoped=true&"
import script from "./uploadDelivery.vue?vue&type=script&lang=js&"
export * from "./uploadDelivery.vue?vue&type=script&lang=js&"
import style0 from "./uploadDelivery.vue?vue&type=style&index=0&id=5c53c1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53c1ae",
  null
  
)

export default component.exports